import { Producto } from '../despacho/Producto';
import { Rubro } from '../despacho/Rubro';
import { ImpuestoPercepcion } from './ImpuestoPercepcion';
export class Renglon {
  id: string;
  cantidad: number;
  detalle: string;
  producto: Producto;
  precio: number;
  precioBase: number;
  iva: number;
  impuestoInterno: number;
  co2: number;
  percepcionesIngresosBrutos: number;
  percepcionesMunicipales: number;
  percepcionesIva: number;
  tipoNeto: number;
  impuestoInternoTotal: number;
  ivaTotal: number;
  co2Total: number;
  subtotalRenglon: number;
  rubro: Rubro;
  productoNombre: string;
  productoCodigo: string;
  unidadMedida: number;
  abreviacionUnidadMedida: string;
  impuestosPercepciones: ImpuestoPercepcion[];
}
